module.exports = __webpack_public_path__ + "img/icon-promo-badge-mozzarella.75436138.png";